// Funcion para extraer los media_file_ids asociados al richtext 
// y poder pasarlos como parametro aparte a la api
export const extractMediaFileIdsFromContentObject = (contentObject) => {
  const ids = new Set();  

  let parsed;

  try {
    if (typeof contentObject === 'string') {
      const outer = JSON.parse(contentObject); // string => object
      if (!outer?.jsonStr) return [];
      parsed = JSON.parse(outer.jsonStr); // double parse
    } else {
      if (!contentObject?.jsonStr) return [];
      parsed = JSON.parse(contentObject.jsonStr); // direct
    }
  } catch (err) {
    console.warn("Invalid content JSON:", err);
    return [];
  }
  

  function walk(node) {
    if (!node) return;
    if (Array.isArray(node)) {
      node.forEach(walk);
      return;
    }

    if (node.attrs?.media_file_id) {
      ids.add(node.attrs.media_file_id);
    }

    if (node.content) {
      walk(node.content);
    }
  }

  walk(parsed);
  return Array.from(ids);
}